import React, { useEffect, useRef, useState } from 'react';
import { LOGO_PATH, LOGO_SUBPATHS, LOGO_VIEWBOX, LOGO_RATIO } from '../lib/logoPath';
import { SPLASH_MS, SPLASH_FADE_MS, prefersReducedMotion } from '../lib/splash';

// Black screen. The winged horse is drawn as a thin orange line (2 s), then fills with the orange gradient; RIDEBURAQ fades in (letter-spacing tightens); ONE tagline;
// a hair-thin orange progress line fills over the whole time. No "loading" words or dots. It stays 5 seconds (the page loads underneath), then fades out; a tap skips it.
// Reduced motion: the finished logo, wordmark and tagline, no animation, for the same 5 seconds.
export default function LuxurySplash({ onDone, reducedMotion = prefersReducedMotion() }) {
  const [leaving, setLeaving] = useState(false);
  const done = useRef(false);
  const finish = () => { if (!done.current) { done.current = true; if (onDone) onDone(); } };

  useEffect(() => {                                              // after 5 seconds the fade-out starts
    const t = setTimeout(() => setLeaving(true), SPLASH_MS - SPLASH_FADE_MS);
    return () => clearTimeout(t);
  }, []);
  useEffect(() => {                                              // safety net if the fade-out never reports back
    if (!leaving) return undefined;
    const t = setTimeout(finish, SPLASH_FADE_MS + 150);
    return () => clearTimeout(t);
  // eslint-disable-next-line
  }, [leaving]);

  const cls = ['rb-splash', reducedMotion ? 'rb-splash-static' : '', leaving ? 'rb-splash-out' : ''].filter(Boolean).join(' ');
  return (
    <div className={cls} data-testid="splash-screen" role="img" aria-label="RideBuraq, Luxury Transportation" onClick={() => setLeaving(true)} onAnimationEnd={(e) => { if (e.animationName === 'rbSplashOut') finish(); }}>
      {!reducedMotion && (
        <picture aria-hidden="true">
          <source media="(max-width: 767px)" type="image/webp" srcSet="/images/booking-hero-m-800.webp" />
          <img className="rb-splash-sky" src="/images/booking-hero-1024.jpg" alt="" decoding="async" />
        </picture>
      )}
      <div className="rb-splash-content" aria-hidden="true">
        <svg className="rb-splash-logo" viewBox={LOGO_VIEWBOX} style={{ aspectRatio: String(LOGO_RATIO) }}>
          <defs>
            <linearGradient id="rbOrange" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#FB923C" />
              <stop offset="100%" stopColor="#EA580C" />
            </linearGradient>
          </defs>
          <path className="rb-logo-fill" d={LOGO_PATH} fill="url(#rbOrange)" fillRule="evenodd" />
          {LOGO_SUBPATHS.map((d, i) => (
            <path key={i} className="rb-logo-line" d={d} pathLength="1" fill="none" stroke="#F97316" strokeWidth="1.6" strokeLinejoin="round" strokeLinecap="round" />
          ))}
        </svg>
        <p className="rb-splash-word"><span>RIDE</span><span className="rb-splash-word-b">BURAQ</span></p>
        <p className="rb-splash-tag">Luxury Transportation</p>
        <div className="rb-splash-track"><div className="rb-splash-bar" /></div>
      </div>
    </div>
  );
}
